import { usePathname } from 'next/navigation';
import { denormalizeAlgoliaFilterName } from './algoliaHelpers';
import { FEATURED_BRANDS_PATH } from './filters';

export const useFeaturedBrand = (): string | null => {
    const pathname = usePathname();
    const isFeaturedBrandPage = pathname?.includes(FEATURED_BRANDS_PATH);

    if (isFeaturedBrandPage) {
        return denormalizeAlgoliaFilterName(pathname?.split('/')[2] ?? '');
    }

    return null;
};
